import { render, staticRenderFns } from "./productform.vue?vue&type=template&id=3764357c&"
import script from "./productform.vue?vue&type=script&lang=js&"
export * from "./productform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports